module.exports = __webpack_public_path__ + "static/media/1.05a21f23.jpg";